/* eslint-disable */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  DtpContentContainer,
  DtpNoContent,
  DtpTabGroup,
  DtpTab,
} from 'dtp-react-components';
import {
  Button,
} from '../../../components/index';
import {
  buscaDestinatarios,
  doGet,
  doPost,
  trataMensagensErro,
  trataMensagemSucesso,
  validateObject,
  doPut,
  requestTiposDocumentos,
  doMultipartFormPost,
  doMultipartFormPostExigencias,
  requestMotivos,
} from '../../../utils/requests';
import {
  getObject,
} from '../../../utils/listsSelect';
import DadosRequerimentoPensao from './DadosRequerimentoPensao';
import ProtectedItem from '../../../components/ComponentesAutenticacao/ProtectedItem';
import ListaExigencias from '../ListaExigencias';
import DadosHistoricoRequerimento from '../DadosHistoricoRequerimento';
import ListaAlertas from '../ListaAlertas';
import ModalAlerta from '../ModalAlerta';
import {
  msgsConfirmacao,
  msgsConfirmacaoIndeferimento,
  alertaPesquisarDadosBeneficio,
} from '../../../utils/constants';
import { manterApenasFiltro, habilitarUploadNaConsultaDoRequerimento } from '../../../utils/helpers';
import User from '../../../domain/User';
import ModalRejeicaoRequerimento from '../../consultas/Exigencia/ModalRejeicaoRequerimento';
import * as constantes from '../../../utils/constants';

const camposPreenchidosPorServico = {
  cnis: [
    'isObtidoPelaRFB',
  ],
  centralService: [
    'dataInicioBeneficio',
    'dataCessacaoBeneficio',
    'dataInicioPagamentoBeneficio',
    'rendaMensalInicial',
    'dataCreditoPagamento',
    'idUOMantenedora',
  ],
};

const camposCnis = [
  'nome',
];

class RequerimentoPensao extends Component {
  constructor() {
    super();
    const initialState = this.getInitialState();
    this.state = initialState;
  }

  getInitialState = () => ({
    acao: 'novo',
    requerimento: {
      cpf: null,
      nome: null,
      estado: null,
      matricula: null,
      destinatario: null,
      solicitanteOrigem: null,
      numeroBeneficio: null,
      numeroBeneficioAposentadoria: null,
      dataInicioBeneficio: null,
      dataInicioPagamentoBeneficio: null,
      dataCessacaoBeneficio: null,
      rendaMensalInicial: null,
      dependentes: [],
      exigencias: [],
      documentosProbatorios: [],
      idUOMantenedora: null,
      arquivos: [],
      listaMotivosIndeferimento: [],
      tipoSegregacaoSolicitante: null,
      tipoSegregacaoDestinatario: null,
    },
    matriculaLabel: {},
    destinatarioLabel: [],
    touched: false,
    cpfTouched: false,
    isObtidoPelaRFB: false,
    validadeCampos: {
      cpf: false,
      destinatario: false,
      dataInicioBeneficio: false,
      rendaMensalInicial: false,
      dependentes: false,
      idUOMantenedora: false,
    },
    tipoRequerimento: 2,
    sucessoUpload: false,
    mostraPaginaSemConteudo: false,
    mensagemPrincipalSemConteudo: 'Requerimento não encontrado para o protocolo informado.',
    mensagemSecundariaSemConteudo: 'Informe um protocolo válido.',
    requestPesquisa: false,
    estadoFormulario: 'inicial',
    camposDependentesInvalidos: null,
    isFetchExigencias: false,
    // Vinicius
    dependentesOrigem: [],
    showModalAlerta: false,
    chaveConfirmacao: null,
    isRmiZerada: false,
    rendaMensalInicialRequest: null,
    requerimentoVindoDoRequest: null,
    houveAlteracaoDependente: null,
    cumpriuAlgumaExigencia: null,
    exibirCampoUoInss: false,
    exibirUploadArquivosNaConsulta: false,
    habilitarBotaoCarregarDocumento: false,
    exigenciasOriginais: [],
    validadeBotoesIndeferidos: {
      pesquisarDadosPessoais: false,
      pesquisarDadosBeneficio: false,
    },
    nomeVindoDaRFB: null,
    exibirModalDataCessacao: false,
    inIndefericaoAnalise: false,
    motivosIndeferimentoControle: [],
    rejeitar: false,
    destinatariosAposentadoria: [],
    tipoDocumento: null,
  })

  componentDidMount() {
    if (this.props.destinatarios.length === 0) {
      buscaDestinatarios(this.handleErrorBusca);
    }
    if (this.props.tiposDocumentos.length === 0) {
      requestTiposDocumentos(this.handleErrorBusca);
    }
    this.montaFormulario();
  }

  componentDidUpdate(prevProps) {
    if (this.props.destinatarios.length !== prevProps.destinatarios.length
      || this.props.tiposDocumentos.length !== prevProps.tiposDocumentos.length) {
      if (this.props.destinatarios.length > 0
        && this.props.tiposDocumentos.length > 0) {
        this.montaFormulario();
      }
    }
  }

  getLotacao = (roles) => {
    let array = '';
    const lotacao = [];
    roles.forEach((role) => {
      const eNovo = role.match(/TD/g);
      const temPA = role.indexOf('|PA|') !== -1;
      if (temPA && eNovo) {
        array = role.split('|');
        for (let i = 0, tam = array.length; i < tam; i += 1) {
          if (array[i] === 'TD') {
            lotacao.push(array[i + 3]);
            break;
          }
        }
      }
    });
    return lotacao;
  }

  /**
   *  Se URL possuir protocolo, requerimento deve ser buscado.
   *  Se URL possuir acao, atualizar state com acao indicada,
   *  senao assume-se que o usuario apenas consulta o requerimento quando protocolo for informado
   *  Protocolo deve ser numerico;
   *  Acao deve ser cumprir-exigencia, realizar-analise ou emitir-parecer-medico.
   */
  montaFormulario = () => {
    if (this.props.match.params.protocolo) {
      if (this.props.destinatarios.length > 0 && this.props.tiposDocumentos.length > 0) {
        const acao = this.props.match.params.acao ? this.props.match.params.acao : 'consulta';
        this.setState({ acao }, this.buscaRequerimento);
      }
    } else {
      manterApenasFiltro('');
      if (this.props.auth.checkPermission(['requerer-compensacao-rgps', 'gerenciar-negocio-dcomp'])) {
        this.setState({
          validadeCampos: {
            ...this.state.validadeCampos,
            numeroBeneficio: false,
          },
        }, this.buscarTiposDocumentosUpload);
      }
      if (this.props.auth.checkPermission(['requerer-compensacao-rpps'])) {
        this.setState(this.buscaParticipantePeloCnpjLogado());
        this.setState({ validadeCampos: { ...this.state.validadeCampos, matricula: false } });
        this.setState({
          validadeCampos: {
            ...this.state.validadeCampos,
            matricula: false,
          },
        }, this.buscarTiposDocumentosUpload);
      }
    }
  }

  /**
   * Busca o requerimento de pensao
   */
  buscaRequerimento(metodoSucesso = this.handleSuccessBuscaRequerimento) {
    if (this.state.acao !== 'novo') {
      const url = `requerimentos-compensacao-pensao/${this.props.match.params.protocolo}`;
      doGet(url, metodoSucesso, this.handleErrorBuscaRequerimento);
    }
  }

  buscaRequerimentoAposRejeitar(response) {
      const url = `requerimentos-compensacao-pensao/${response.data.protocolo}`;
      doGet(url, this.handleSuccessBuscaRequerimentoAposSalvarERejeitar, this.handleErrorBuscaRequerimento);
  }

  handleSuccessBuscaParticipantePeloCnpjLogado = (response) => {
    const { requerimento } = { ...this.state };
    requerimento.idUOMantenedora = response.data.idUOInssConvenio;
    this.setState({
      requerimento: { ...this.state.requerimento, requerimento },
    });
  }

  handleErrorBuscaParticipantePeloCnpjLogado = () => {
    const mensagemPrimaria = 'Não foi possível consultar o ente participante.';
    const mensagemSecundaria = 'Contate o administrador do sistema.';

    this.setState({
      showNoContent: true,
      noContentPrimaryMessage: mensagemPrimaria,
      noContentSecondaryMessage: mensagemSecundaria,
    });
  };

  handleErrorBuscaDocumentosUpload = () => {
    const mensagemPrimaria = 'Não foi possível consultar os documentos para upload.';
    const mensagemSecundaria = 'Contate o administrador do sistema.';

    this.setState({
      showNoContent: true,
      noContentPrimaryMessage: mensagemPrimaria,
      noContentSecondaryMessage: mensagemSecundaria,
    });
  };

  buscarTiposDocumentosUpload = () => {
    requestTiposDocumentos(this.handleErrorBuscaDocumentosUpload);
  }

  buscarTiposDocumentos = () => {
    requestTiposDocumentos(this.handleErrorBusca);
  }

  buscaParticipantePeloCnpjLogado =
  (metodoSucesso = this.handleSuccessBuscaParticipantePeloCnpjLogado) => {
    const lotacaoUsuario = this.getLotacao(this.props.auth.userData.roles);

    if (lotacaoUsuario.length > 0) {
      const primParte = [];
      const segParte = [];
      if (lotacaoUsuario[0].indexOf('#') !== -1) {
        const arrayLotacao = lotacaoUsuario[0].split('#');
        primParte.push(arrayLotacao[0]);
        segParte.push(arrayLotacao[1]);
      }
      const url = `participantes-compensacao/${segParte}`;
      doGet(
        url,
        metodoSucesso,
        this.handleErrorBuscaParticipantePeloCnpjLogado,
      );
    }
  }
  validacaoErrosDependentes = (errosDependente, isDelete = null) => {
    let camposInvalidos = null;
    if (isDelete) {
      camposInvalidos = errosDependente;
    } else {
      camposInvalidos = this.state
        .camposDependentesInvalidos.filter(erro => (errosDependente.includes(erro) ? null : erro));
    }
    this.setState({ camposDependentesInvalidos: camposInvalidos });
  }

  montaValidadeCampos = (requerimento) => {
    const { validadeCampos } = { ...this.state };
    Object.keys(validadeCampos).forEach((key) => {
      validadeCampos[key] = true;
    });
    if (this.state.acao === 'cumprir-exigencia'
    && requerimento.estado === 2 && requerimento.exigencias) {
      const exigenciaComAtributo = [];
      requerimento.exigencias
        .forEach((exigencia) => {
          if (exigencia.atributo) {
            if (exigencia.codigoDependente) {
              validadeCampos.dependentes = false;
            } else {
              exigenciaComAtributo.push(exigencia);
            }
          }
          if (exigencia.tipo === 10 || exigencia.tipo === 11) {
            validadeCampos.dependentes = false;
          }
        });
      exigenciaComAtributo.forEach((exigencia) => {
        validadeCampos[exigencia.atributo] = false;
      });
    }
    return validadeCampos;
  }

  isConsultaExigencia = () => (this.state.acao === 'consulta' && this.state.requerimento.estado === 2);

  verificaIndefericaoAnalise = () => {
    const { estados } = { ...this.state.requerimento };
    let { motivosIndeferimentoControle } = { ...this.state };
    if (estados && estados.length > 0) {
      if (estados[0].motivos && estados[0].motivos.length > 0) {
        motivosIndeferimentoControle = estados[0].motivos;
        this.setState({ motivosIndeferimentoControle, inIndefericaoAnalise: true });
        const changeObj = {value: 9};
        this.alteraEstadoRequerimento(changeObj);
        requestMotivos();
      }
    }
  }

  handleSuccessBuscaRequerimento = (response) => {
    const validadeCampos = this.montaValidadeCampos(response.data);
    let { exibirCampoUoInss } = { ...this.state };
    if (response.data) {
      const requerimentoVindoDoRequest = response.data;
      const solicitanteRGPS = 
      requerimentoVindoDoRequest.solicitante && requerimentoVindoDoRequest.solicitante.codigo === '01000';
      const destinatarioRGPS = 
      requerimentoVindoDoRequest.destinatario && requerimentoVindoDoRequest.destinatario.codigo === '01000';
      
      if (response.data.estado === 2) { // em exigência mas pode nao ser consulta
        this.setState({ requerimentoVindoDoRequest });
        // IB 282195
        if (this.state.acao === 'consulta') { 
          let { exigenciasOriginais } = { ...this.state };
          let { exibirUploadArquivosNaConsulta } = { ...this.state };
          requerimentoVindoDoRequest.exigencias.forEach((exigencia) => {
            exigenciasOriginais.push(exigencia);
          });
          const usuario = User.logged();
          const isCpfLogadoIgualCpfUsuarioResponsavel = (usuario.data.prevCpf === requerimentoVindoDoRequest.cpfUsuarioResponsavel);
         // isCpfLogadoIgualCpfUsuarioResponsavel é o cpf de quem pegou o requerimento para analisar no GET
          if (!solicitanteRGPS) {
          exibirUploadArquivosNaConsulta = true;
          } else if (isCpfLogadoIgualCpfUsuarioResponsavel && solicitanteRGPS) {
          exibirUploadArquivosNaConsulta = true;
          }
          this.setState({ exigenciasOriginais, exibirUploadArquivosNaConsulta });
        }
      }
      // IB 282195
      if (this.state.acao === 'consulta' && response.data.estado !== 2) {
        const paramUploadArquivosNaConsulta =
        habilitarUploadNaConsultaDoRequerimento(requerimentoVindoDoRequest, this.state.acao, null);
        this.setState({ exibirUploadArquivosNaConsulta: paramUploadArquivosNaConsulta });
      }

      if (this.state.acao === 'indeferidos') {
        validadeCampos.solicitanteOrigem = true;
      }

      if (solicitanteRGPS || destinatarioRGPS) {
        exibirCampoUoInss = true;
        this.setState({ exibirCampoUoInss });
      }
    }
    const matriculaLabel = {};
    matriculaLabel[response.data.destinatario.codigo] = [{
      label: response.data.matricula,
      value: response.data.matricula,
    }];
    const destinatarioLabel = Object.keys(matriculaLabel).map(item => (
      {
        label: getObject(this.props.destinatarios, item).label,
        value: item,
      }
    ));
    let dependentes = [];
    if (response.data.dependentes) {
      dependentes = response.data.dependentes.map(dependente => ({ ...dependente }));
    }

    this.setState({
      requerimento: { ...this.state.requerimento, ...response.data },
      touched: true,
      validadeCampos,
      matriculaLabel,
      destinatarioLabel,
      // Vinicius
      dependentesOrigem: dependentes,
    }, this.buscarTiposDocumentos);
    if (this.state.requerimento.estado === 6) {
      this.verificaIndefericaoAnalise();
    }
  }

  handleSuccessBuscaRequerimentoAposSalvarERejeitar = (response) => {
    this.setState({
      requerimento: { ...this.state.requerimento, ...response.data },
    });
  }

  handleSuccessBuscaRequerimentoAtualizacao = (response) => {
    const validadeCampos = this.montaValidadeCampos(response.data);
    if (response.data) {
      if (response.data.estado === 2) {
        const requerimentoVindoDoRequest = response.data;
        this.setState({ requerimentoVindoDoRequest });
        this.setState({ houveAlteracaoDependente: false });
      }
    }
    this.setState({
      requerimento: response.data,
      touched: true,
      isFetchExigencias: false,
      validadeCampos,
    }, this.validaVoltaPagina);
  }

  validaVoltaPagina = () => {
    if (!this.state.requerimento.exigencias
      || this.state.requerimento.exigencias
        .filter(exigencia => exigencia.tipoDocumento).length
          === this.state.requerimento.exigencias.length) {
      this.props.history.goBack();
    }
  }

  handleErrorBuscaRequerimento = (error) => {
    let mensagemPrimaria = 'Não foi possível consultar o requerimento.';
    let mensagemSecundaria = 'Contate o administrador do sistema.';
    if (error) {
      if (error.status) {
        if (error.status === 404) {
          mensagemPrimaria = 'Requerimento não encontrado para o protocolo informado.';
          mensagemSecundaria = 'Informe um protocolo válido.';
        }
      }
    }
    this.setState({
      mostraPaginaSemConteudo: true,
      mensagemPrincipalSemConteudo: mensagemPrimaria,
      mensagemSecundariaSemConteudo: mensagemSecundaria,
    });
  }

  handleErrorBusca = () => {
    const mensagemPrimaria = 'Não foi possível realizar a consulta.';
    const mensagemSecundaria = 'Contate o administrador do sistema.';
    this.setState({
      mostraPaginaSemConteudo: true,
      mensagemPrincipalSemConteudo: mensagemPrimaria,
      mensagemSecundariaSemConteudo: mensagemSecundaria,
    });
  }

  buscaPorNomeNaLista = (dependenteAlterado, dependentes) => {
    const dependente = dependentes.filter(dep => dep.nome && dep.nome === dependenteAlterado.nome);
    return dependente;
  }

  isDestinatarioRGPS = (changeObj) => {
    return changeObj && changeObj.value === '01000';
  }

  isSolicitanteRGPS = () => {
    return User.logged().isRGPS();
  }

  alteraListaArquivos = (arquivos) => {
    this.handleChange({ value: arquivos, isValid: arquivos.length > 0 }, 'arquivos');
  }

  addArquivo = (arquivo) => {
    let retorno = {};
    if (arquivo) {
      const { requerimento } = { ...this.state };
      const { tipoDocumento } = { ...this.state };
      retorno = {
        documento: arquivo,
        protocolo: requerimento.protocolo,
        tipoDocumento: tipoDocumento,
      };
    }
    return retorno;
  }

  handleChangeTipoDocumento = (e, name) => {
    this.setState({
      [name]: e.value,
    });
  }

  handleChangeFile = (arquivo) => {
    if (!arquivo) {
      this.alteraListaArquivos([], null);
      return;
    }
    const tamanhoDocumentoUpload = arquivo.size;
    // inclusão
    if ((tamanhoDocumentoUpload > constantes.tamanhoMaximoArquivoUpload)) {
      trataMensagensErro([
        `Certifique-se de que o documento ${arquivo.name} possui tamanho inferior a 3 mb.`,
      ]);
    } else {
      const novoArquivo = this.addArquivo(arquivo);

      this.alteraListaArquivos([novoArquivo], null);
    }
  }
  /**
   * Trata o estado do formulario e alteracoes de campos.
   * Formulario deve ser considerado:
   *  - Inicial quando ainda nao enviado para validacao de regras no servico;
   *  - Alterado quando formulario montado com dados do servico e ao menos um campo foi alterado.
   *  - Enviado quando o formulario foi enviado para validacao no servico.
   */
  handleChange = (changeObj, name, callback = null) => {
    let { estadoFormulario } = { ...this.state };
    const { requerimento } = { ...this.state };
    let valido = changeObj.isValid;
    let destinatarioIndeferido = {};

    if (this.state.acao === 'cumprir-exigencia') {
      estadoFormulario = 'alterado';
      const { requestPesquisa } = { ...this.state };
      if (requestPesquisa) {
        this.setState({ requestPesquisa: false });
      }
      requerimento.exigencias.forEach((exigencia) => {
        if (exigencia.atributo === name) {
          // eslint-disable-next-line
          exigencia.atendida = 1;
        }
        if (name === 'dependentes' &&
          this.testaSeCumpriuExigenciaEmDependentes(exigencia, changeObj.value)) {
          // eslint-disable-next-line
          exigencia.atendida = 1;
        } else if (name === 'dependentes' &&
        !this.testaSeCumpriuExigenciaEmDependentes(exigencia, changeObj.value)) {
          this.setState({ houveAlteracaoDependente: true });
        }
      });
    } else if (this.state.acao === 'novo' && estadoFormulario === 'erro-regra') {
      estadoFormulario = 'alterado';
    }
    if (name === 'arquivos' && this.state.acao !== 'consulta') {
      valido = true;
    }else if (name === 'arquivos' && this.state.acao === 'consulta') {
      if (valido) {
        this.setState({ habilitarBotaoCarregarDocumento: true });
      } else {
        this.setState({ habilitarBotaoCarregarDocumento: false });
      }
    }
    if (name === 'destinatario') {
      const { validadeCampos } = { ...this.state };
      validadeCampos.solicitanteOrigem = true;
      let { exibirCampoUoInss } = { ...this.state };
      if (this.isDestinatarioRGPS(changeObj) || this.isSolicitanteRGPS(changeObj)) {
        exibirCampoUoInss = true;
      } else {
        exibirCampoUoInss = false;
      }
      this.setState({
        exibirCampoUoInss,
      });

      requerimento.tipoSegregacaoSolicitante = null;
      requerimento.tipoSegregacaoDestinatario = null;
    } 
    if (name === 'destinatario' && this.state.acao === 'indeferidos') {
      destinatarioIndeferido = {
        codigo: changeObj.value,
      };
    }

    if (name === 'rendaMensalInicial') {
      if (changeObj.value === '') {
          valido = false;
      }
    }

    if (name === 'matricula') {
      const { destinatariosAposentadoria } = { ...this.state };
      const indexDestinatarioAposentadoria =
      destinatariosAposentadoria.findIndex(dest => (dest.matricula === changeObj.value && dest.destinatario === requerimento.destinatario));
      const existeIndex = indexDestinatarioAposentadoria !== -1;
      
      if (existeIndex) {
        const existeSegregacaoSolicitante = destinatariosAposentadoria[indexDestinatarioAposentadoria].tipoSegregacaoSolicitante !== undefined;
        const existeSegregacaoDestinatario = destinatariosAposentadoria[indexDestinatarioAposentadoria].tipoSegregacaoDestinatario !== undefined;

        if (existeSegregacaoSolicitante) {
          requerimento.tipoSegregacaoSolicitante = destinatariosAposentadoria[indexDestinatarioAposentadoria].tipoSegregacaoSolicitante;
        } else {
          requerimento.tipoSegregacaoSolicitante = null;
        }

        if (existeSegregacaoDestinatario) {
          requerimento.tipoSegregacaoDestinatario = destinatariosAposentadoria[indexDestinatarioAposentadoria].tipoSegregacaoDestinatario;     
        } else {
          requerimento.tipoSegregacaoDestinatario = null;      
        }
      }
    }

    this.setState({
      requerimento: {
        ...requerimento,
        [name]: destinatarioIndeferido.codigo ? destinatarioIndeferido : changeObj.value,
      },
      validadeCampos: {
        ...this.state.validadeCampos,
        [name]: valido,
      },
      estadoFormulario,
    }, callback);
  }

  handleChangeDestinatario = (changeObj, name) => {
    const { requerimento } = { ...this.state };
    const arrayMatricula = this.state.matriculaLabel;

    arrayMatricula.forEach((item) => {
      if (item.value === changeObj.value) {
        requerimento.matricula = item.label;
      }
    });

    this.setState({
      requerimento: {
        ...requerimento,
        [name]: changeObj.value,
      },
      validadeCampos: {
        ...this.state.validadeCampos,
        [name]: changeObj.isValid,
      },
    });
  }

  handleKeyUp = (e) => {
    let retorno = e.target.value;
    if (retorno.indexOf('_') !== -1) {
      retorno = retorno.toString().replace('_', '');
    }
    retorno = retorno.toString().replace(/\D/g, '');
    retorno = retorno.toString().replace(/(\d)(\d{11})$/, '$1.$2');
    retorno = retorno.toString().replace(/(\d)(\d{8})$/, '$1.$2');
    retorno = retorno.toString().replace(/(\d)(\d{5})$/, '$1.$2');
    retorno = retorno.toString().replace(/(\d)(\d{2})$/, '$1,$2');
    e.target.value = retorno;

    return retorno;
  }

  cumpreExigenciasEmAtributosDeServico = (reqResponse) => {
    // camposPreenchidosPorServico
    // cnis
    // benMigrado - centralService
    const { data } = { ...reqResponse };
    const { requerimento } = { ...this.state };
    const { exigencias } = { ...requerimento };
    if (this.state.acao === 'cumprir-exigencia'
      && exigencias) {
      requerimento.exigencias.forEach((exigencia) => {
        if (data[exigencia.atributo] &&
          data[exigencia.atributo] !== requerimento[exigencia.atributo]) {
          // eslint-disable-next-line
          exigencia.atendida = 1;
        }
      });
    }
    return requerimento;
  }

  trataSucessoResponsePesquisa = (response) => {
    const { validadeCampos } = { ...this.state };
    // const requerimentoAtual = this.state.requerimento;
    const requerimento = this.cumpreExigenciasEmAtributosDeServico(response);
    camposPreenchidosPorServico[this.state.requestPesquisa].forEach((key) => {
      validadeCampos[key] = true;
    });

    // Apaga campos quando nao vierem do serviço
    if (!response.data.dataInicioBeneficio) {
      requerimento.dataInicioBeneficio = null;
      validadeCampos.dataInicioBeneficio = false;
    }

    if (!response.data.dataCessacaoBeneficio) {
      requerimento.dataCessacaoBeneficio = null;
    }

    if (!response.data.rendaMensalInicial) {
      if (response.data.rendaMensalInicial === 0) {
        if (requerimento.rendaMensalInicial !== null) {
          requerimento.rendaMensalInicial = '';
        }
        response.data.rendaMensalInicial = null;
        validadeCampos.rendaMensalInicial = false;
        this.setState({
          isRmiZerada: true,
          rendaMensalInicialRequest: null,
        });
      }
    } else if (this.state.isRmiZerada) {
      this.setState({
        isRmiZerada: false,
      });
    }

    if (!response.data.dataCreditoPagamento) {
      requerimento.dataCreditoPagamento = null;
      // validadeCampos.dataCreditoPagamento = false;
    }

    if (!response.data.idUOMantenedora) {
      requerimento.idUOMantenedora = null;
      validadeCampos.idUOMantenedora = false;
    }

    if (this.state.acao === 'indeferidos') {
      const { validadeBotoesIndeferidos } = { ...this.state };
      if (validadeBotoesIndeferidos.pesquisarDadosBeneficio === false) {
        validadeBotoesIndeferidos.pesquisarDadosBeneficio = true;
      }
      this.setState({ validadeBotoesIndeferidos });
    }

    this.setState({
      requerimento: {
        ...requerimento,
        ...response.data,
      },
      requestPesquisa: null,
      validadeCampos,
    });
  }

  handleNBSearch = () => {
    if (this.state.requerimento.numeroBeneficio) {
      const { numeroBeneficio } = { ...this.state.requerimento };

      this.setState(
        { requestPesquisa: 'centralService' },
        doGet(
          `/beneficio-rgps-pensao/${numeroBeneficio}`,
          this.trataSucessoResponsePesquisa,
          this.trataErrosResponse,
        ),
      );
    }
  }

  /**
   * Trata o click no botão de busca por NB no BenMigrado. - centralService
   */
  handleSearchNBButton = () => {
    const numeroBeneficioTouched = true;
    this.setState({ ...this.state, numeroBeneficioTouched }, this.handleNBSearch);
  }

  testaSeCumpriuExigenciaEmDependentes = (exigencia, dependentes) => {
    // Se exigencia de inclusao ou exclusao, verificar tamanho do array
    if (exigencia.tipo === 10 && dependentes.length > this.state.requerimento.dependentes.length) {
      return true;
    }
    if (exigencia.tipo === 11 && dependentes.length < this.state.requerimento.dependentes.length) {
      return true;
    }
    if (exigencia.codigoDependente) {
      const novoDependente = this.buscaDependenteNaLista(exigencia, dependentes);
      const estadoDependente =
        this.buscaDependenteNaLista(exigencia, this.state.requerimento.dependentes);
      if (Object.keys(novoDependente).length !== 0 && Object.keys(estadoDependente).length !== 0 &&
        novoDependente[exigencia.atributo] !== estadoDependente[exigencia.atributo]) {
        return true;
      }
    }
    return false;
  }

  buscaDependenteNaLista = (exigencia, dependentes) => {
    const dependente = dependentes.filter(dep => dep.codigo &&
      dep.codigo === exigencia.codigoDependente);
    if (dependente && dependente.length > 0) {
      return dependente[0];
    }
    return {};
  }

  /**
   * Controla a alteracao do estado do requerimento resultado da analise
   */
  alteraEstadoRequerimento = (changeObj) => {
    if (changeObj.value !== 9 && (this.state.motivosIndeferimentoControle &&
      this.state.motivosIndeferimentoControle.length > 0)) {
      this.setState({inIndefericaoAnalise: false});
    }
    this.setState({
      requerimento: {
        ...this.state.requerimento,
        exigencias: [],
        motivo: null,
        justificativaIndeferimento: null,
      },
    }, () => this.handleChange(changeObj, 'estado'));
  }

  verificaCumprimentoExigencia = () => {
    let exigenciaCumprida = false;
    let houveAlteracaoNoRequerimento = false;
    if (this.state.requerimento.exigencias) {
      this.state.requerimento.exigencias.forEach((item) => {
        if (item.atributo) {
          if (item.atributo in this.state.validadeCampos
          && this.state.validadeCampos[item.atributo]) {
            exigenciaCumprida = true;
          }
          if (item.codigoDependente && this.state.validadeCampos.dependentes) {
            exigenciaCumprida = true;
          }
        }
        // Vinicius
        if (item.tipo === 10) {
          this.state.requerimento.dependentes.forEach((dependente) => {
            let encontrei = false;
            this.state.dependentesOrigem.forEach((dependenteOrigem) => {
              if (dependente.nome === dependenteOrigem.nome
                && dependente.dataNascimento === dependenteOrigem.dataNascimento) {
                encontrei = true;
              }
            });
            if (!encontrei) {
              exigenciaCumprida = true;
            }
          });
        }
        if (item.tipo === 11) {
          this.state.dependentesOrigem.forEach((dependenteOrigem) => {
            let encontrei = false;
            this.state.requerimento.dependentes.forEach((dependente) => {
              if (dependente.nome === dependenteOrigem.nome
                && dependente.dataNascimento === dependenteOrigem.dataNascimento) {
                encontrei = true;
              }
            });
            if (!encontrei) {
              exigenciaCumprida = true;
            }
          });
        }
        if (item.tipo === 12) {
          this.state.dependentesOrigem.forEach((dependenteOrigem) => {
            this.state.requerimento.dependentes.forEach((dependente) => {
              if (dependente.codigo === dependenteOrigem.codigo && dependente.cpfDependente !== '') {
                exigenciaCumprida = true;
              }
            });
          });
          this.state.requerimento.exigencias.forEach((exigencia) => {
            const paramAtributo = exigencia.atributo;
              if (paramAtributo in this.state.validadeCampos && exigenciaCumprida) {
                this.state.validadeCampos[paramAtributo] = true;
            }
          });
        }
      });
    }
    if (exigenciaCumprida) {
      this.state.requerimento.exigencias.forEach((exigencia) => {
        const paramAtributo = exigencia.atributo;
        if (paramAtributo && exigencia.atendida === 1) {
          if (paramAtributo in this.state.validadeCampos) {
            this.state.validadeCampos[paramAtributo] = true;
          }
        }
      });
      const valido = validateObject(this.state.validadeCampos);
      this.state.requerimento.exigencias.forEach((exigencia) => {
        const paramAtributo = exigencia.atributo;
        if (paramAtributo && exigencia.atendida === 0) {
          if (paramAtributo in this.state.validadeCampos) {
            this.state.validadeCampos[paramAtributo] = false;
          }
        }
      });
      if (!valido) {
        houveAlteracaoNoRequerimento = valido;
      } else {
        houveAlteracaoNoRequerimento = exigenciaCumprida;
      }
    } else {
      houveAlteracaoNoRequerimento = this.verificaAlteracaoCamposEstadoExigencia();
      const { requestPesquisa } = { ...this.state };
      const alterouPeloBotaoPesquisar = requestPesquisa;
      if (alterouPeloBotaoPesquisar) {
        return true;
      }
      if (houveAlteracaoNoRequerimento && !this.state.houveAlteracaoDependente) {
        this.state.requerimento.exigencias.forEach((exigencia) => {
          const paramAtributo = exigencia.atributo;
          if (paramAtributo && exigencia.atendida === 0) {
            if (paramAtributo in this.state.validadeCampos) {
              this.state.validadeCampos[paramAtributo] = true;
            }
          }
          //provisorio
          this.state.validadeCampos.dependentes = true;
        });

        houveAlteracaoNoRequerimento = validateObject(this.state.validadeCampos);

        this.state.requerimento.exigencias.forEach((exigencia) => {
          const paramAtributo = exigencia.atributo;
          if (paramAtributo && exigencia.atendida === 0) {
            if (paramAtributo in this.state.validadeCampos) {
              this.state.validadeCampos[paramAtributo] = false;
            }
          }
        });
      } else {
        const { houveAlteracaoDependente } = { ...this.state };
        if (houveAlteracaoDependente) {
          return true;
        }
      }
    }
    return houveAlteracaoNoRequerimento;
  }

  formularioProntoParaEnvio = () => {
    const { acao } = { ...this.state };
    const { estadoFormulario } = { ...this.state };
    const { requerimento } = { ...this.state };
    switch (acao) {
      case 'novo': {
        if (estadoFormulario === 'inicial') {
          this.state.validadeCampos.idUOMantenedora = true;
          return validateObject(this.state.validadeCampos);
        }
        if (estadoFormulario === 'criado') {
          return true;
        }
        if (estadoFormulario === 'alterado') {
          return validateObject(this.state.validadeCampos);
        }
      }
      case 'cumprir-exigencia':
        return this.verificaCumprimentoExigencia();
      case 'realizar-analise': return this.verificaSeAnaliseCompleta();
      case 'emitir-parecer-medico': return this.verificaSeAnaliseMedicoCompleta();
      case 'consulta':
        return (habilitarUploadNaConsultaDoRequerimento(requerimento, acao, null) &&
        this.state.habilitarBotaoCarregarDocumento);
      case 'indeferidos': {
        if(this.props.auth.checkPermission(['requerer-compensacao-rgps', 'analisar-compensacao-rgps'])) {
          return this.verificaIndeferidos('rgps');
        }
        if(this.props.auth.checkPermission(['analisar-compensacao-rpps', 'requerer-compensacao-rpps'])) {
          return this.verificaIndeferidos('rpps');
        }
      }
      case 'salvarERejeitar':
        return validateObject(this.state.validadeCampos);
      default: return false;
    }
  }

  verificaIndeferidos = (regime) => {
    let retorno = true;
    if (regime === 'rgps') {
      let camposValidosRMIZerada = true;

      if (this.state.isRmiZerada) {
        camposValidosRMIZerada = this.state.isRmiZerada && this.state.validadeCampos.rendaMensalInicial;
      }

      retorno = this.state.validadeBotoesIndeferidos.pesquisarDadosBeneficio && camposValidosRMIZerada;
    } else {
        retorno = this.state.validadeCampos.dataInicioBeneficio
        && this.state.validadeCampos.rendaMensalInicial;
    }

    return retorno;
  }

  verificaAlteracaoCamposEstadoExigencia = () => {
    const { requerimento } = { ...this.state };
    const { requerimentoVindoDoRequest } = { ...this.state };
    const reqOriginal = requerimentoVindoDoRequest;
    const reqAtual = requerimento;
    let houveAlteracao = false;

    if (reqOriginal !== null) {
      if (reqAtual.idUOMantenedora !== undefined) {
        if (reqOriginal.idUOMantenedora &&
          ((reqOriginal.idUOMantenedora !== reqAtual.idUOMantenedora)
          && reqAtual.idUOMantenedora !== null)) {
          houveAlteracao = true;
        }
      }
      if (reqAtual.nome !== undefined) {
        if (reqOriginal.nome &&
          ((reqOriginal.nome !== reqAtual.nome) && reqAtual.nome !== null)) {
          houveAlteracao = true;
        }
      }
      if (reqAtual.dataNascimento !== undefined) {
        if (reqOriginal.dataNascimento &&
          ((reqOriginal.dataNascimento !== reqAtual.dataNascimento) &&
          reqAtual.dataNascimento !== null)) {
          houveAlteracao = true;
        }
      }
      if (reqAtual.nomeMae !== undefined) {
        if (reqOriginal.nomeMae &&
          ((reqOriginal.nomeMae !== reqAtual.nomeMae) &&
          reqAtual.nomeMae !== null)) {
          houveAlteracao = true;
        }
      }
      if (reqAtual.dataInicioBeneficio !== undefined) {
        if (reqOriginal.dataInicioBeneficio &&
          ((reqOriginal.dataInicioBeneficio !== reqAtual.dataInicioBeneficio) &&
          reqAtual.dataInicioBeneficio !== null)) {
          houveAlteracao = true;
        }
      }
      if (reqAtual.dataInicioPagamentoBeneficio !== undefined) {
        if ((reqOriginal.dataInicioPagamentoBeneficio === undefined &&
          reqAtual.dataInicioPagamentoBeneficio !== null) ||
          ((reqOriginal.dataInicioPagamentoBeneficio !== reqAtual.dataInicioPagamentoBeneficio)
          && reqAtual.dataInicioPagamentoBeneficio !== null)) {
          houveAlteracao = true;
        }
      }
      if (reqAtual.dataCessacaoBeneficio !== undefined) {
        if ((reqOriginal.dataCessacaoBeneficio === undefined &&
          reqAtual.dataCessacaoBeneficio !== null) ||
          ((reqOriginal.dataCessacaoBeneficio !== reqAtual.dataCessacaoBeneficio)
          && reqAtual.dataCessacaoBeneficio !== null)) {
          houveAlteracao = true;
        }
      }
      if (reqAtual.rendaMensalInicial !== undefined) {
        if (reqOriginal.rendaMensalInicial &&
          ((reqOriginal.rendaMensalInicial !== reqAtual.rendaMensalInicial) &&
          reqAtual.rendaMensalInicial !== null)) {
          houveAlteracao = true;
        }
      }
      if (this.props.auth.checkPermission(['requerer-compensacao-rpps'])) {
        if (reqAtual.dataHomologacaoTribunalContas !== undefined) {
          if ((reqOriginal.dataHomologacaoTribunalContas === undefined &&
            reqAtual.dataHomologacaoTribunalContas !== null) ||
            ((reqOriginal.dataHomologacaoTribunalContas !== reqAtual.dataHomologacaoTribunalContas)
            && reqAtual.dataHomologacaoTribunalContas !== null)) {
            houveAlteracao = true;
          }
        }
      } else if (this.props.auth.checkPermission(['requerer-compensacao-rgps',
        'analisar-compensacao-rgps', 'gerenciar-negocio-dcomp'])) {
        if (reqAtual.dataCreditoPagamento !== undefined) {
          if ((reqOriginal.dataCreditoPagamento === undefined &&
            reqAtual.dataCreditoPagamento !== null) ||
            ((reqOriginal.dataCreditoPagamento !== reqAtual.dataCreditoPagamento)
            && reqAtual.dataCreditoPagamento !== null)) {
            houveAlteracao = true;
          }
        }
      }
    }
    return houveAlteracao;
  }

verificaAlteracaoCamposDependente = (depAtual, depOriginal) => {
  let houveAlteracao = false;

  if (depOriginal !== null) {
    if (depAtual.cpfDependente !== undefined) {
      if ((depOriginal.cpfDependente === undefined &&
        depAtual.cpfDependente !== null) ||
        (depOriginal.cpfDependente !== depAtual.cpfDependente)) {
        houveAlteracao = true;
      }
    }
    if (depAtual.nome !== undefined) {
      if (depOriginal.nome &&
        (depOriginal.nome !== depAtual.nome)) {
        houveAlteracao = true;
      }
    }
    if (depAtual.nomeMae !== undefined) {
      if (depOriginal.nomeMae &&
        (depOriginal.nomeMae !== depAtual.nomeMae)) {
        houveAlteracao = true;
      }
    }
    if (depAtual.dataNascimento !== undefined) {
      if (depOriginal.dataNascimento &&
        (depOriginal.dataNascimento !== depAtual.dataNascimento)) {
        houveAlteracao = true;
      }
    }
    if (depAtual.sexo !== undefined) {
      if (depOriginal.sexo &&
        (depOriginal.sexo !== depAtual.sexo)) {
        houveAlteracao = true;
      }
    }
    if (depAtual.estadoCivil !== undefined) {
      if (depOriginal.estadoCivil &&
        (depOriginal.estadoCivil !== depAtual.estadoCivil)) {
        houveAlteracao = true;
      }
    }
    if (depAtual.vinculo !== undefined) {
      if (depOriginal.vinculo &&
        (depOriginal.vinculo !== depAtual.vinculo)) {
        houveAlteracao = true;
      }
    }
    if (depAtual.capacidade !== undefined) {
      if (depOriginal.capacidade &&
        (depOriginal.capacidade !== depAtual.capacidade)) {
        houveAlteracao = true;
      }
    }
    if (depAtual.motivoInclusao !== undefined) {
      if ((depOriginal.motivoInclusao === undefined &&
        depAtual.motivoInclusao !== null) ||
        (depOriginal.motivoInclusao !== depAtual.motivoInclusao)) {
        houveAlteracao = true;
      }
    }
  }
  return houveAlteracao;
}

  verificaSeAnaliseCompleta = () => {
    switch (this.state.requerimento.estado) {
      case 2: return this.state.requerimento.exigencias.length > 0;
      case 8: return true;
      case 9: return this.state.motivosIndeferimentoControle.length > 0;
      case 10: return typeof this.state.requerimento.motivo === 'number';
      default: return false;
    }
  }

  verificaSeAnaliseMedicoCompleta = () => {
    const dependentesAnaliseMedico = this.state.requerimento.dependentes
      .filter(item => item.capacidade === 3 || item.capacidade === 5);
    return dependentesAnaliseMedico.every(item => 'invalidezDeAcordoMedico' in item);
  }

  // Busca requerimentos de aposentadoria por CPF
  handleSearchButton = () => {
    const cpfTouched = true;
    this.setState({ ...this.state, cpfTouched }, this.handleSearch);
  }

  handleSearch = () => {
    if (this.state.requerimento.cpf) {
      const { cpf } = { ...this.state.requerimento };
      this.setState(
        { requestPesquisa: true },
        doGet(
          'requerimentos-compensacao',
          this.buscaPeloCpfSucesso,
          this.callbackFalhaBuscaCpf,
          {
            cpf,
            'tipo-requerimento': 1,
            participacao: 1,
          },
        ),
      );
    }
  }
   /**
  * Trata o click no botão de alteração da data de cessação
  */
    handleModalAlteraDataCessacao = () => {
      this.setState({ exibirModalDataCessacao: !this.state.exibirModalDataCessacao });
    }

  /**
   * Trata as respostas positivas em caso de submissao de formulario (POST, PUT)
   */
  handleFechamentoModalAlerta = () => {
    this.setState({
      chaveConfirmacao: null,
      alertas: [],
      showModalAlerta: !this.state.showModalAlerta,
    });
  }

  buscaPeloCpfSucesso = (response) => {
    try {
      if (response.data) {
        this.setState({
          destinatariosAposentadoria: response.data,
        });
        if (response.data[0].solicitante !== '01000') {
          this.trataBuscaPeloCpfRPPS(response);
        } else {
          this.trataBuscaPeloCpfRGPS(response);
        }
      } else {
        this.setState(
          {
            ...this.state,
            matriculaLabel: {},
            destinatarioLabel: [],
            requerimento: {
              ...this.state.requerimento,
              nome: '',
              matricula: null,
              destinatario: null,
            },
          },
          trataMensagensErro(['Não foram encontrados requerimentos de compensação de aposentadoria associados ao CPF informado.']),
        );

      }
    } catch (err) {
      trataMensagensErro(['Ocorreu uma falha de comunicação com o serviço de compensação previdenciária.']);
    }
  }

  callbackFalhaBuscaCpf = (error) => {
    this.setState({
      ...this.state,
      matriculaLabel: {},
      destinatarioLabel: [],
      requerimento: {
        ...this.state.requerimento,
        nome: '',
        matricula: null,
        destinatario: null,
      },
    }, () => this.trataErrosResponse(error));
  }

  // Trata o retorno quando busca de requerimentos de aposentadoria
  // por cpf quando solicitante for RPPS
  trataBuscaPeloCpfRPPS = (response) => {
    const matriculaLabel = {};
    response.data.forEach((item) => {
      if (item.estado !== 9 && item.estado !== 14 && item.estado !== 16) {
        if (item.destinatario in matriculaLabel) {
          matriculaLabel[item.destinatario].push({ label: item.matricula, value: item.matricula });
        } else {
          matriculaLabel[item.destinatario] = [{
            label: item.matricula,
            value: item.matricula,
          }];
        }
      }
    });
    const destinatarioLabel = Object.keys(matriculaLabel).map(item => (
      {
        label: getObject(this.props.destinatarios, item).label,
        value: item,
      }));
    // IB372216 - Alteração da pesquisa de CPF do requerimento de pensão
    const cpf = response.data[0].cpf;
    //const nome = response.data[0] ? response.data[0].nome : '';

    this.setState({
      ...this.state,
      matriculaLabel,
      destinatarioLabel,
      // requerimento: {
      //   ...this.state.requerimento,
      //   nome,
      // },
    }, this.pesquisarNomeNaRFB(cpf));
  }

  trataSucessoResponsePesquisaCpfPensao = (response) => {
    this.setState({
      requerimento: {
        ...this.state.requerimento,
        nome: response.data.nome,
      },
    });
  }

  // IB372216 - Alteração da pesquisa de CPF do requerimento de pensão
  pesquisarNomeNaRFB(cpf) {
    this.setState(
      { requestPesquisa: false },
      doGet(
        `pessoas-fisicas/${cpf}`,
        this.trataSucessoResponsePesquisaCpfPensao,
        this.trataErrosResponse,
      ),
    );
  }

  // Trata o retorno quando busca de requerimentos de aposentadoria
  // por cpf quando solicitante for RGPS
  trataBuscaPeloCpfRGPS = (response) => {
    const destinatarioLabel = [];
    const matriculaLabel = [];
    const { requerimento } = { ...this.state };
    response.data.forEach((item) => {
      if (item.estado !== 9 && item.estado !== 14 && item.estado !== 16) {
        destinatarioLabel.push({
          label: getObject(this.props.destinatarios, item.destinatario).label,
          value: item.destinatario,
        });
        if (item.matricula) {
          matriculaLabel.push({
            label: item.matricula,
            value: item.destinatario,
          });
        }
      }
    });
    requerimento.numeroBeneficioAposentadoria = response.data[0].numeroBeneficio;
    const cpf = response.data[0].cpf;
    
    // const nome = response.data[0] ? response.data[0].nome : '';
    // const nome = (this.state.nomeVindoDaRFB !== null) ? this.state.nomeVindoDaRFB : '';

    this.setState({
      ...this.state,
      destinatarioLabel,
      matriculaLabel,
      // requerimento: {
      //   ...this.state.requerimento,
      //   nome,
      // },
    },this.pesquisarNomeNaRFB(cpf));
  }

  // Trata o retorno quando busca de requerimentos de aposentadoria
  // por cpf quando solicitante for RGPS
  // trataBuscaPeloCpfRGPS = (response) => {
  //   const { requerimento } = { ...this.state };
  //   const destinatarioLabel = [];
  //   const matriculaLabel = [];
  //   response.data.forEach((item) => {
  //     destinatarioLabel.push({
  //       label: getObject(this.props.destinatarios, item.destinatario).label,
  //       value: item.destinatario,
  //     });
  //   });

  //   requerimento.numeroBeneficioAposentadoria = response.data[0].numeroBeneficio;
  //   requerimento.matricula = response.data[0].matricula;

  //   const nome = response.data[0] ? response.data[0].nome : '';
  //   this.setState({
  //     ...this.state,
  //     destinatarioLabel,
  //     matriculaLabel,
  //     requerimento: {
  //       ...this.state.requerimento,
  //       nome,
  //     },
  //   });
  // }

  trataErrosResponse = (error) => {
    const { validadeCampos } = { ...this.state };
    const { requerimento } = { ...this.state };
    if (error && error.tipo === 2) {
      const { data } = { ...error };
      this.setState({
        chaveConfirmacao: data.chaveConfirmacao,
        alertas: data.alertas,
        showModalAlerta: !this.state.showModalAlerta,
      });
    } else {
        if (this.state.requestPesquisa) {
          if (typeof this.state.requestPesquisa !== 'boolean') {
          camposPreenchidosPorServico[this.state.requestPesquisa].forEach((key) => {
            validadeCampos[key] = false;
            requerimento[key] = '';
          });
          this.setState({
            requerimento: { ...this.state.requerimento, requerimento },
            validadeCampos,
          });
        }
      }
      if (error) {
        const { data } = { ...error };
        if (error.status === 400) {
          const camposDependentesInvalidos = [];
          if (data.erros && data.erros.length >= 1) {
            data.erros.forEach((erro) => {
              if (erro.atributo in this.state.validadeCampos) {
                validadeCampos[[erro.atributo]] = false;
              }
              // Olhar isso depois
              // eslint-disable-next-line
              if (erro.hasOwnProperty('indiceLista')) {
                camposDependentesInvalidos.push(erro);
                validadeCampos.dependentes = false;
              }
              if (this.state.acao === 'cumprir-exigencia'
              && requerimento.estado === 2 && requerimento.exigencias) {
                const exigenciaComAtributo = requerimento.exigencias.filter(item => item.atributo);
                exigenciaComAtributo.forEach((exigencia) => {
                  validadeCampos[exigencia.atributo] = false;
                });
              }
            });
            this.setState({
              ...this.state, validadeCampos, camposDependentesInvalidos, estadoFormulario: 'erro-regra',
            });
          }
          const { acao } = { ...this.state };
          if (acao === 'cumprir-exigencia'
            && requerimento.estado === 2 && requerimento.exigencias) {
            const exigenciaComAtributo =
            requerimento.exigencias.filter(item => item.atributo);
            exigenciaComAtributo.forEach((exigencia) => {
              validadeCampos[exigencia.atributo] = false;
            });
          }
          this.setState({
            ...this.state, validadeCampos, camposDependentesInvalidos, estadoFormulario: 'erro-regra',
          });

          const { validadeBotoesIndeferidos } = { ...this.state };
          if (this.state.requestPesquisa === 'centralService' && validadeBotoesIndeferidos.pesquisarDadosBeneficio === true) {
              validadeBotoesIndeferidos.pesquisarDadosBeneficio = false;
              this.setState({ validadeBotoesIndeferidos });
          }

          // if (this.state.requestPesquisa === 'cnis' && validadeBotoesIndeferidos.pesquisarDadosPessoais === true) {
          //     validadeBotoesIndeferidos.pesquisarDadosPessoais = false;
          //     this.setState({ validadeBotoesIndeferidos });
          // }
        }
      }
    }
  }
  // deleteMotivos = (motivo) => {
  //   const url = `requerimentos-compensacao/motivos/${motivo.protocolo}/${requerimento.estado}/${motivo.dataInicio}/${motivo.motivo}`;
  //   doDeleteMotivo(url,'','','');
  // }

  extrairMotivosParaSalvar = () => {
    const { motivosIndeferimentoControle } = { ...this.state };
    if (motivosIndeferimentoControle.length > 0) {
      const { requerimento } = { ...this.state };
      var lista = [];
      motivosIndeferimentoControle.forEach((item) => {
        lista.push(item.motivo);
      });
      requerimento.listaMotivosIndeferimento = lista;
      this.setState({ ...requerimento });
    }
  }

  /**
   * Trata o click do botao de submissao do formulario
   * Se analise estiver indeferindo, exibir alerta de confirmacao
   */
  handleSaveButton = () => {
    if (this.state.acao === 'consulta') {
      this.uploadFileAvulso();
    } else {
      if (this.state.requerimento.estado === 9) {
        this.extrairMotivosParaSalvar();
        this.setState({
          alertas: [msgsConfirmacao.indeferimento],
          showModalAlerta: !this.state.showModalAlerta,
        });
      } else if (this.state.acao === 'cumprir-exigencia') {
        let alteracaoDep = false;
        this.state.requerimento.dependentes.forEach((dependente) => {
          this.state.dependentesOrigem.forEach((dependenteOrigem) => {
            if (alteracaoDep) {
              return;
            }  
            if ((this.verificaAlteracaoCamposDependente(dependente, dependenteOrigem)) === true) {
              alteracaoDep = true;
              return;
            }                     
          });
        });
      // caso ele tenha dependentes anteriores e tenha excluido os dependentes
        if (this.state.requerimento.dependentes.length !=  this.state.dependentesOrigem.length) {
          alteracaoDep = true;
        }
        if (!this.verificaAlteracaoCamposEstadoExigencia() && !alteracaoDep) {
          trataMensagensErro(['Não foram identificadas modificações no requerimento.']);
        } else {
          this.confirmSendData();
        }
      } else if (this.state.acao === 'indeferidos') {
        const { requerimento } = { ...this.state };
        requerimento.estado = 3;
        let mensagemConfirmacao = '';
        mensagemConfirmacao = msgsConfirmacaoIndeferimento.reaberturaIndeferimento;
        this.setState({
          requerimento: { ...requerimento },
          alertas: [mensagemConfirmacao],
          showModalAlerta: !this.state.showModalAlerta,
        });
      } else {
        this.confirmSendData();
      }
    }
  }

  handleSaveButtonConfirmarIndeferimento = () => {
    // this.setState({ requerimento: { ...this.state.requerimento, estado: 16 }});
    // this.confirmSendData();
    const { requerimento } = { ...this.state };
    requerimento.estado = 16;
    let mensagemConfirmacao = '';
    mensagemConfirmacao = msgsConfirmacaoIndeferimento.indeferimento;
    this.setState({
      requerimento: { ...requerimento },
      alertas: [mensagemConfirmacao],
      showModalAlerta: !this.state.showModalAlerta,
    });
  }

  onClickSalvarERejeitarRequerimento = () => {
    const requerimento = { ...this.state.requerimento };
    if(this.isSolicitanteRGPS()) {
      requerimento.solicitante = '01000';
    }
    this.setState({
      acao:'salvarERejeitar',
      requerimento: {
        ...requerimento,
      },
      showRejeicaoRequerimentoModal: !this.state.showRejeicaoRequerimentoModal });
  }

  atualizarMotivoRejeicao = (paramMotivo, paramJustificativa) => {
    const requerimento = { ...this.state.requerimento };
    requerimento.motivo = paramMotivo;
    requerimento.justificativaRejeicao = paramJustificativa
    this.setState({
      requerimento: {
        ...requerimento,
      }
    },() => this.confirmSendData());
    ;
  }

  confirmSendData = () => {
    const touched = true;
    let url = 'requerimentos-compensacao-pensao';
    if (this.state.acao !== 'novo') {
      if (this.state.acao === 'salvarERejeitar') {
        url = 'requerimentos-compensacao-pensao/solicitar-e-rejeitar';
      } else {
        url = `requerimentos-compensacao-pensao/${this.state.requerimento.protocolo}`;
      }
    }
    // Alteração para transformar o valor do campo rendaMensalInicial
    // para numero antes de persistir na tabela.
    if (typeof (this.state.requerimento.rendaMensalInicial) !== 'number') {
      let renda = this.state.requerimento.rendaMensalInicial;
      renda = renda.replace(/\./g, '').replace(/,/g, '.');
      //this.state.requerimento.rendaMensalInicial = Number(renda);
      this.setState({
        requerimento: {
          ...this.state.requerimento,
          rendaMensalInicial: Number(renda),
        },
      });
    }

    // Vinicius
    const { validadeCampos } = { ...this.state };
    const camposDependentesInvalidos = [];
    Object.keys(validadeCampos).forEach((key) => {
      validadeCampos[key] = true;
    });

    this.setState({
      touched,
      validadeCampos,
      camposDependentesInvalidos,
      requestPesquisa: false,
    }, () => this.handleSave(url));
  }

  handleSave = (url) => {
    if (this.formularioProntoParaEnvio() || this.state.requerimento.estado === 16) {
      let options;
      if (this.state.chaveConfirmacao) {
        options = { 'Chave-Confirmacao': this.state.chaveConfirmacao };
      }
      const { requerimento } = { ...this.state };
      if (this.state.acao === 'novo' || this.state.acao === 'salvarERejeitar') {
        doPost(
          url,
          requerimento,
          this.trataSucessoResponseEnvio,
          this.trataErrosResponse,
          options,
        );
      } else {
        doPut(
          url,
          requerimento,
          this.trataSucessoResponseEnvio,
          this.trataErrosResponse,
          {
            codigo: 3009,
            mensagem: 'Esta solicitação já foi atendida por outro usuário.',
          },
          options,
        );
      }
    } else if (!this.state.validadeCampos.dependentes && this.state.acao === 'novo') {
      trataMensagensErro(['Informe o dependente do requerimento de compensação de pensão.']);
    } else {
      trataMensagensErro(['Informe corretamente os atributos indicados na tela.']);
    }
  }

  handleDocumentSent = () => {
    this.setState({ sucessoUpload: true });
  }

  handleFailDocumentSent = () => {
  }

  uploadFile = (response) => {
    const { requerimento } = { ...this.state };
    if (this.state.acao === 'novo') {
      requerimento.protocolo = response.headers.location.substring(
        response.headers.location.lastIndexOf('/') + 1,
        response.headers.location.length,
      );
    }
    const url = 'documentos';
    const documentos = requerimento.arquivos;
    if (documentos.length > 0) {
      for (let i = 0, docs = documentos.length; i < docs; i += 1) {
        const body = {
          protocolo: requerimento.protocolo,
          tipoDocumento: documentos[i].tipoDocumento,
          documento: documentos[i].documento,
        };
        doMultipartFormPost(
          url,
          body,
          this.handleDocumentSent,
          this.handleFailDocumentSent,
        );
      }
    }
  }

  trataSucessoUploadAvulso = () => {
    const { requerimento } = { ...this.state };
    this.setState({ sucessoUpload: true });
    if (this.state.sucessoUpload) {
      let mensagemSucesso = ['Documentos anexados ao requerimento com sucesso.'];
      // if (this.isConsultaExigencia()) {
      //   mensagemSucesso = 'Documento(s) anexado(s) ao requerimento com sucesso.';
      // }
      requerimento.arquivos = [];
      this.setState({
        habilitarBotaoCarregarDocumento: false,
        requerimento,
      }, this.atualizarDocumentosProbatorios);
      trataMensagemSucesso(mensagemSucesso);
    }
  }

  handleFailUploadAvulso = () => {
    const mensagemErro = ['Falha ao anexar documento(s) ao requerimento.'];
    trataMensagensErro(mensagemErro);
  }

  trataSucessoResponseDocs = (response) => {
    const { requerimento } = { ...this.state };
    const listaDocs = response.data;
    this.setState({
      requerimento: {
        ...requerimento,
        documentosProbatorios: listaDocs,
      },
    });
  }

  uploadFileAvulso = () => {
    const { requerimento } = { ...this.state };
    const url = 'documentos';
    if (requerimento.estado === 2) {
      const documentos = requerimento.arquivos;
      if (documentos.length > 0) {
        const listaExigencias = requerimento.exigencias;
        const listaDependentes = requerimento.dependentes;
        let tipoDocumentoUpload = '';
        let documentoUpload = '';
        let body = '';

        if (listaDependentes && listaDependentes.length > 0 &&
          listaExigencias && listaExigencias.length > 0) {
          for (let i = 0, tam = listaDependentes.length; i < tam; i += 1) {
            for (let j = 0, exi = listaExigencias.length; j < exi; j += 1) {
              for (let k = 0, arq = documentos.length; k < arq; k += 1) {
                  let dependenteUpload = listaDependentes[i];
                  let exigencia = listaExigencias[j];
                  let arquivo = documentos[k];
                  if (dependenteUpload.codigo === exigencia.codigoDependente &&
                    arquivo.tipoDocumento === exigencia.tipoDocumento) {
                    tipoDocumentoUpload = exigencia.tipoDocumento;
                    documentoUpload = arquivo;
                    documentos[k].carregar = true;
                    documentos[k].dependente = dependenteUpload;
                    documentos[k].tipoDocumento = tipoDocumentoUpload;
                  } else {
                    // tipoDocumentoUpload = exigencia.tipoDocumento !== undefined ? exigencia.tipoDocumento : arquivo.tipoDocumento;
                    documentoUpload = arquivo;
                    documentos[k].carregar = true;
                    documentos[k].tipoDocumento = exigencia.tipoDocumento !== undefined ? exigencia.tipoDocumento : arquivo.tipoDocumento;
                  }
                }
              }
            }
          }

          documentos.forEach((documento) => {
            if (documento.carregar) {
              body = {
                protocolo: requerimento.protocolo,
                documento: documento.documento,
                tipoDocumento: documento.tipoDocumento,
              };
              doMultipartFormPostExigencias(
                url,
                body,
                this.trataSucessoUploadAvulso,
                this.handleFailUploadAvulso,
              );
            }
          });
        }        
    } else {
      // const url = 'documentos';
      const documentos = requerimento.arquivos;
      if (documentos.length > 0) {
        for (let i = 0, docs = documentos.length; i < docs; i += 1) {
          const body = {
            protocolo: requerimento.protocolo,
            tipoDocumento: documentos[i].tipoDocumento,
            documento: documentos[i].documento,
          };
          doMultipartFormPost(
            url,
            body,
            this.trataSucessoUploadAvulso,
            this.handleFailUploadAvulso,
          );
        }
      }
    }
  }

  atualizarDocumentosProbatorios = async () => {
    // if(this.state.acao !== 'indeferidos') {
    //   await this.sleep(3000);
    // } else {
      await this.sleep(1000);
    // }
    doGet(
      `/requerimentos-compensacao-pensao/documentos-probatorios/${this.state.requerimento.protocolo}`,
      this.trataSucessoResponseDocs,
      this.trataErrosResponse,
    );
  }

  sleep = (time) => {
    return new Promise((resolve) => setTimeout(resolve, time));
  }

  /**
   * Trata as respostas positivas em caso de submissao de formulario (POST, PUT)
   */
  trataSucessoResponseEnvio = (response) => {
    if (this.state.acao === 'novo' || this.state.acao === 'indeferidos') {
      this.uploadFile(response);
      if (this.state.sucessoUpload) {
        const mensagemSucesso = ['Documentos anexados ao requerimento com sucesso.'];
        trataMensagemSucesso(mensagemSucesso);
      }
    }
    if (this.state.acao === 'salvarERejeitar') {
      this.buscaRequerimentoAposRejeitar(response);      
    }

    // if (this.state.acao === 'realizar-analise') {
    //   const { requerimento } = { ...this.state };
    //   const { motivosIndeferimentoControle } = { ...this.state };
    //   if (requerimento.estado !== 9 && 
    //     (motivosIndeferimentoControle && motivosIndeferimentoControle.length > 0)) {
    //     motivosIndeferimentoControle.forEach((motivo) => {
    //         this.deleteMotivos(motivo);
    //     });
    //   }
    // } 

    if (this.state.chaveConfirmacao) {
      this.setState({
        chaveConfirmacao: null,
        alertas: [],
      }, this.trataSucesso);
    } else {
      this.trataSucesso();
    }
  }

  /**
   * Trata a mensagem de sucesso ao criar/editar requerimento e redireciona para
   * consulta se nao for novo requerimento.
   */
  trataSucesso = () => {
    let mensagemSucesso = 'Requerimento aberto.';
    let houveAlteracao = this.verificaAlteracaoCamposEstadoExigencia();
    let cumpriuExigencia = false;
    const { houveAlteracaoDependente } = { ...this.state };
    switch (this.state.acao) {
      case 'novo': {
        this.setState({
          estadoFormulario: 'criado',
        });
        break;
      }
      case 'cumprir-exigencia':
        mensagemSucesso = 'Requerimento atualizado.';
        houveAlteracao = this.verificaAlteracaoCamposEstadoExigencia();
        // mensagemSucesso = 'Requerimento atualizado e exigência encerrada.';
        this.state.requerimento.exigencias.forEach((exigencia) => {
          if (exigencia.atendida) {
            cumpriuExigencia = true;
          }
        });

        if (houveAlteracao && cumpriuExigencia) {
          mensagemSucesso = 'Requerimento atualizado e exigência encerrada.';
        } else if ((houveAlteracao && !cumpriuExigencia) ||
        (houveAlteracaoDependente && (!houveAlteracao && !cumpriuExigencia))) {
          mensagemSucesso = 'Requerimento atualizado.';
        }

        this.buscaRequerimento(this.handleSuccessBuscaRequerimentoAtualizacao);
        break;
      case 'realizar-analise':
        mensagemSucesso = 'Requerimento analisado.';
        this.props.history.goBack();
        break;
      case 'emitir-parecer-medico':
        mensagemSucesso = 'Requerimento atualizado com o parecer do médico.';
        this.props.history.goBack();
        break;
      // default: mensagemSucesso = 'Requerimento atualizado e exigência encerrada.';
      case 'indeferidos': {
        mensagemSucesso = 'Requerimento atualizado com sucesso.';
        this.props.history.goBack();
        break;
      }
      case 'salvarERejeitar': {
        mensagemSucesso = 'Requerimento criado no estado rejeitado.';
        this.handleModalRejeicaoRequerimento();
        this.setState({
          acao: 'novo',
          estadoFormulario: 'criado',
        });
        
        break;
      }
      default: mensagemSucesso = 'Requerimento atualizado.';
    }
    trataMensagemSucesso([mensagemSucesso]);
  }

  // Trata o clique no botao de "Novo Requerimento"
  handleNewButton = () => {
    if (this.props.auth.checkPermission(['requerer-compensacao-rpps'])) {
      this.setState(this.buscaParticipantePeloCnpjLogado());
    }
    this.setState(
      { ...this.getInitialState(), reset: true },
      () => this.setState({ reset: false }, () => window.scrollTo(0, 0)),
    );
  }

  checkIsFetchExigencias = () => {
    this.setState({ isFetchExigencias: !this.state.isFetchExigencias });
  }

  formularioRequerimento = () => (
    <DadosRequerimentoPensao
      acao={this.state.acao}
      alteraEstadoRequerimento={this.alteraEstadoRequerimento}
      auth={this.props.auth}
      camposCnis={camposCnis}
      estadoFormulario={this.state}
      match={this.props.match}
      handleChange={this.handleChange}
      handleChangeDestinatario={this.handleChangeDestinatario}
      handleKeyUp={this.handleKeyUp}
      handleSearchButton={this.handleSearchButton}
      tiposDocumentos={this.props.tiposDocumentos}
      checkIsFetchExigencias={this.checkIsFetchExigencias}
      validacaoErrosDependentes={this.validacaoErrosDependentes}
      handleSearchNBButton={this.handleSearchNBButton}
      arquivos={this.props.arquivos}
      camposCentralService={camposPreenchidosPorServico.centralService}
      listaExigencias={this.state.exigenciasOriginais}
      atualizarDocumentosProbatorios={this.atualizarDocumentosProbatorios}
      temBloqueioAtivoContratoDtp={this.props.temBloqueioAtivoContratoDtp}
      handleModalAlteraDataCessacao={this.handleModalAlteraDataCessacao}
      exibirModalDataCessacao={this.state.exibirModalDataCessacao}
      atualizarDataCessacao={this.atualizarDataCessacao}
      handleChangeTipoDocumento={this.handleChangeTipoDocumento}
      handleChangeFile={this.handleChangeFile}
    />
  );

  montaCorpoRequerimento = () => {
    const corpoRequerimento = (
      <DtpTabGroup className="dtp-default">
        {this.montaTabs()}
      </DtpTabGroup>
    );
    return corpoRequerimento;
  }

  tabRequerimento = () => (
    <DtpTab id="item1" className="active" title="Requerimento">
      {this.formularioRequerimento()}
    </DtpTab>
  );

  tabHistorico = () => (
    <DtpTab id="item2" title="Estados">
      <DadosHistoricoRequerimento
        historicoEstados={this.state.requerimento.estados}
        auth={this.props.auth}
      />
    </DtpTab>
  )

  montaTabs = () => {
    const listaTabs = [];
    listaTabs.push(this.tabRequerimento());
    if (this.state.requerimento.estados) {
      listaTabs.push(this.tabHistorico());
    }
    return listaTabs;
  }

  obterMensagens (dataAbertura) {
    let mensagem = [];
    mensagem.push({ descricao: `A Data de Criação do Requerimento em ${dataAbertura} não será alterada.`});
    if (this.props.auth.checkPermission(['requerer-compensacao-rgps', 'analisar-compensacao-rgps'])) {
      mensagem = mensagem.concat(alertaPesquisarDadosBeneficio);
    }

    return mensagem;
  }

  atualizarDataCessacao = (dataCessacao) => {
    const requerimento = { ...this.state.requerimento };
    requerimento.dataCessacaoBeneficio = dataCessacao;
    this.setState({ requerimento });
  }

  onClickRejeitarRequerimento = () => {
    /**
  * Trata o click no botão de rejeitar requerimento
  */
    this.setState({ rejeitar: true, showRejeicaoRequerimentoModal: !this.state.showRejeicaoRequerimentoModal });  
  }

  /**
  * Trata o click no botão de rejeitar o requerimento
  */
   handleModalRejeicaoRequerimento = () => {
    if (this.state.acao === 'salvarERejeitar') {
      this.setState({ acao : 'novo', showRejeicaoRequerimentoModal: !this.state.showRejeicaoRequerimentoModal });
    } else{
      this.setState({ rejeitar: false, showRejeicaoRequerimentoModal: !this.state.showRejeicaoRequerimentoModal });
    }
   }

  handleRejeicaoRequerimentoSent = () => {
    const mensagemSucesso = ['Requerimento Rejeitado.'];
    trataMensagemSucesso(mensagemSucesso);
    this.setState({
    }, () => this.handleModalRejeicaoRequerimento());
    this.props.history.goBack();
  }

  exibirBotaoRejeicao = () => {
    const { solicitante } = { ...this.state.requerimento};
    const { requerimento } = { ...this.state};
    const cnpjUsuarioLogado = User.logged().cnpjDoPapel();
    const cnpjSolicitante = solicitante ? solicitante.cnpj: null;
    const codigoSolicitante = solicitante ? solicitante.codigo: null;
    const ehUsuarioRGPS = User.logged().isUsuarioRGPS();
    let retorno = null;

    if ([1, 3, 6, 7, 8, 9, 10, 11, 12, 14, 15, 16, 17].includes(requerimento.estado)) {
      retorno = false;
    } else {
      retorno = (requerimento !== undefined && solicitante !== undefined) &&
        (['consulta', 'cumprir-exigencia'].includes(this.state.acao) && [2, 4, 5, 13, 18].includes(requerimento.estado) && (cnpjSolicitante === cnpjUsuarioLogado) ||
        ((codigoSolicitante === '01000' && (ehUsuarioRGPS)))) || (this.state.rejeitar)
    }
    return retorno;
  };

  render() {
    if (this.state.reset) {
      return null;
    }

    if (this.state.mostraPaginaSemConteudo) {
      return (
        <DtpNoContent
          primaryText={this.state.mensagemPrincipalSemConteudo}
          secondaryText={this.state.mensagemSecundariaSemConteudo}
          show={this.state.mostraPaginaSemConteudo}
        />
      );
    }

    let listaAlertas;
    let listaExigencias;
    let botaoAcaoPrincipal;
    let botaoAcaoVoltar;
    let botaoAcaoConfirmarIndeferimento;
    let botaoRejeitar;
    let botaoSalvarERejeitar;

    const configBotaoPrincipal = {
      onClick: this.handleSaveButton,
    };

    const configBotaoConfirmarIndeferimento = {
      onClick: this.handleSaveButtonConfirmarIndeferimento,
    };

    const configBotaoSalvarERejeitar = {
      onClick: this.onClickSalvarERejeitarRequerimento,
    };

    if (this.state.acao === 'cumprir-exigencia') {
      listaExigencias = (<ListaExigencias exigencias={this.state.requerimento.exigencias} />);
      configBotaoPrincipal.permissoes = ['analisar-compensacao-rgps', 'analisar-compensacao-rpps', 'requerer-compensacao-rgps',
        'requerer-compensacao-rpps', 'gerenciar-negocio-dcomp'];
      configBotaoPrincipal.titulo = 'Salvar';
      configBotaoPrincipal.hint = 'Salvar alterações no requerimento e encerrar exigências atendidas';
    }

    if (this.state.acao === 'realizar-analise') {
      configBotaoPrincipal.permissoes = ['analisar-compensacao-rgps', 'analisar-compensacao-rpps', 'analisar-compensacao-rpps',
        'gerenciar-negocio-dcomp'];
      configBotaoPrincipal.titulo = 'Finalizar Análise';
      configBotaoPrincipal.hint = 'Finalizar a análise do requerimento';
    }
    if (this.state.acao === 'emitir-parecer-medico') {
      configBotaoPrincipal.permissoes = ['fornecer-parecer-medico-rpps'];
      configBotaoPrincipal.titulo = 'Emitir parecer';
      configBotaoPrincipal.hint = 'Emitir parecer do médico perito';
    }

    if (this.state.acao === 'indeferidos') {
      listaAlertas = (<ListaAlertas alertas={this.obterMensagens(this.state.requerimento.dataAberturaRequerimento)} open={true} />);
      configBotaoPrincipal.permissoes = ['requerer-compensacao-rgps', 'analisar-compensacao-rgps',
        'analisar-compensacao-rpps', 'requerer-compensacao-rpps'];
      configBotaoPrincipal.titulo = 'Reabrir requerimento';
      configBotaoPrincipal.hint = 'Reabrir requerimento';

      configBotaoConfirmarIndeferimento.permissoes = ['requerer-compensacao-rgps', 'analisar-compensacao-rgps',
        'analisar-compensacao-rpps', 'requerer-compensacao-rpps'];
      configBotaoConfirmarIndeferimento.titulo = 'Confirmar Indeferimento';
      configBotaoConfirmarIndeferimento.hint = 'Confirmar Indeferimento do requerimento';
    }

    if (this.state.acao === 'novo') {
      if (this.state.estadoFormulario === 'criado') {
        configBotaoPrincipal.permissoes = ['analisar-compensacao-rgps', 'analisar-compensacao-rpps', 'requerer-compensacao-rgps',
          'requerer-compensacao-rpps', 'gerenciar-negocio-dcomp'];
        configBotaoPrincipal.titulo = 'Novo';
        configBotaoPrincipal.hint = 'Criar novo requerimento';
        configBotaoPrincipal.onClick = this.handleNewButton;
      } else {
        configBotaoPrincipal.permissoes = ['analisar-compensacao-rgps', 'analisar-compensacao-rpps', 'requerer-compensacao-rgps',
          'requerer-compensacao-rpps', 'gerenciar-negocio-dcomp'];
        configBotaoPrincipal.titulo = 'Salvar';
        configBotaoPrincipal.hint = 'Salvar requerimento';

        configBotaoSalvarERejeitar.permissoes = ['analisar-compensacao-rgps', 'analisar-compensacao-rpps', 'requerer-compensacao-rgps'];
        configBotaoSalvarERejeitar.titulo = 'Salvar e rejeitar';
        configBotaoSalvarERejeitar.hint = 'Salvar o requerimento e rejeitar';
      }
    } else {
      if ((this.state.acao === 'consulta' && habilitarUploadNaConsultaDoRequerimento(this.state.requerimento, this.state.acao, null)
        && !this.props.temBloqueioAtivoContratoDtp) || this.state.acao === 'rejeitar') {
        configBotaoPrincipal.permissoes = ['analisar-compensacao-rgps', 'analisar-compensacao-rpps', 'requerer-compensacao-rgps',
          'requerer-compensacao-rpps', 'gerenciar-negocio-dcomp'];
        configBotaoPrincipal.titulo = 'Carregar documento';
        configBotaoPrincipal.hint = 'Carregar documento';
      }
      if (this.state.acao === 'salvarERejeitar') {
        configBotaoPrincipal.permissoes = ['analisar-compensacao-rgps', 'analisar-compensacao-rpps', 'requerer-compensacao-rgps',
          'requerer-compensacao-rpps', 'gerenciar-negocio-dcomp'];
        configBotaoPrincipal.titulo = 'Salvar';
        configBotaoPrincipal.hint = 'Salvar requerimento';
        
        configBotaoSalvarERejeitar.permissoes = ['analisar-compensacao-rgps', 'analisar-compensacao-rpps', 'requerer-compensacao-rgps'];
        configBotaoSalvarERejeitar.titulo = 'Salvar e rejeitar';
        configBotaoSalvarERejeitar.hint = 'Salvar o requerimento e rejeitar';
      }
    }
    botaoAcaoVoltar = (
      <Button
        className="left"
        onClick={this.props.history.goBack}
        title="Voltar"
        hint="Voltar para tela anterior"
      />
    );

    if (this.exibirBotaoRejeicao()) {
      botaoRejeitar = (
        <Button
          className="dtp-primary right"
          title="Rejeitar o requerimento"
          onClick={this.onClickRejeitarRequerimento}
          hint="Rejeitar"
        />
      );
    }

    if (configBotaoPrincipal.titulo) {
        if ((this.state.acao === 'salvarERejeitar' || this.state.acao !== 'consulta') ||
        (this.state.acao === 'consulta' && habilitarUploadNaConsultaDoRequerimento(this.state.requerimento, this.state.acao, null))) {
        botaoAcaoPrincipal = (
          <ProtectedItem allowedPermissions={configBotaoPrincipal.permissoes}>
            <Button
              className="dtp-primary right"
              disabled={!this.formularioProntoParaEnvio()}
              title={configBotaoPrincipal.titulo}
              onClick={configBotaoPrincipal.onClick}
              hint={configBotaoPrincipal.hint}
            />
          </ProtectedItem>
        );
      }
    }

    if (configBotaoSalvarERejeitar.titulo) {
      if (this.state.acao === 'novo' || this.state.acao === 'salvarERejeitar') {
        botaoSalvarERejeitar = (
          <ProtectedItem allowedPermissions={configBotaoSalvarERejeitar.permissoes}>
            <Button
              className="dtp-primary right"
              disabled={!this.formularioProntoParaEnvio()}
              title={configBotaoSalvarERejeitar.titulo}
              onClick={configBotaoSalvarERejeitar.onClick}
              hint={configBotaoSalvarERejeitar.hint}
            />
          </ProtectedItem>
        );
      }
    }

    if (configBotaoConfirmarIndeferimento.titulo && this.state.acao === 'indeferidos') {
      botaoAcaoConfirmarIndeferimento = (
        <ProtectedItem allowedPermissions={configBotaoPrincipal.permissoes}>
          <Button
            className="dtp-btn right"
            title={configBotaoConfirmarIndeferimento.titulo}
            onClick={configBotaoConfirmarIndeferimento.onClick}
            hint={configBotaoConfirmarIndeferimento.hint}
          />
        </ProtectedItem>
      );
  }

    let modalAlerta;
    if (this.state.showModalAlerta) {
      modalAlerta = (<ModalAlerta
        alertas={this.state.alertas}
        aceitar={this.confirmSendData}
        handleModal={this.handleFechamentoModalAlerta}
        showModal
      />);
    }

    let modalRejeicaoRequerimento;
    if(this.state.showRejeicaoRequerimentoModal) {
      modalRejeicaoRequerimento = (<ModalRejeicaoRequerimento
        acao={this.state.acao}
        protocolo={this.state.requerimento.protocolo}
        requerimento={this.state.requerimento}
        handleModal={() => this.handleModalRejeicaoRequerimento()}
        showModal
        tipoRequerimento={this.state.tipoRequerimento}
        handleRejeicaoRequerimentoSent={this.handleRejeicaoRequerimentoSent}
        handleSalvarERejeitar={this.atualizarMotivoRejeicao}
        rejeitar={this.state.rejeitar}
      />);
    }

    return (
      <DtpContentContainer>
        {listaAlertas}
        {listaExigencias}
        {this.montaCorpoRequerimento()}
        <div className="row">
          { botaoAcaoVoltar }
          { botaoAcaoPrincipal }
          { botaoSalvarERejeitar }
          { botaoRejeitar }
          { botaoAcaoConfirmarIndeferimento }
        </div>
        {modalAlerta}
        {modalRejeicaoRequerimento}
      </DtpContentContainer>
    );
  }
}

RequerimentoPensao.propTypes = {
  destinatarios: PropTypes.arrayOf({
    label: PropTypes.string,
    value: PropTypes.number,
    tipoRegimeProprio: PropTypes.number,
  }).isRequired,
  history: PropTypes.shape({
    goBack: PropTypes.func,
  }).isRequired,
  match: PropTypes.shape({
    params: PropTypes.shape({
      protocolo: PropTypes.string,
      acao: PropTypes.string,
    }),
  }),
  tiposDocumentos: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.number,
    label: PropTypes.string,
  })),
  arquivos: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.number,
    label: PropTypes.string,
  })),
  auth: PropTypes.shape({
    userData: PropTypes.object,
    checkPermission: PropTypes.func,
  }),
  temBloqueioAtivoContratoDtp: PropTypes.bool.isRequired,
};

RequerimentoPensao.defaultProps = {
  match: null,
  tiposDocumentos: [],
  auth: null,
  arquivos: null,
};

const mapStateToProps = state => ({
  destinatarios: state.base.destinatarios,
  tiposDocumentos: state.base.tiposDocumentos,
  temBloqueioAtivoContratoDtp: state.base.configuracoesFrontend.temBloqueioAtivoContratoDtp,
});

export default connect(mapStateToProps)(RequerimentoPensao);



// WEBPACK FOOTER //
// ./src/pages/requerimentos/Pensao/RequerimentoPensao.jsx